"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSgmReport = exports.sgmReport = void 0;
var getGlobalWindow_1 = require("./getGlobalWindow");
// 监控上报
var sgmReport = function (data) {
    var _a;
    try {
        var wd = (0, getGlobalWindow_1.getWindow)();
        if (!(wd === null || wd === void 0 ? void 0 : wd.__sgm__)) {
            console.log("sgm 不存在，无法上报", data);
        }
        (_a = wd === null || wd === void 0 ? void 0 : wd.__sgm__) === null || _a === void 0 ? void 0 : _a.custom(data);
    }
    catch (error) {
        console.log("sgm上报出错", error);
    }
};
exports.sgmReport = sgmReport;
var setSgmReport = function (sgmFunc) {
    var wd = (0, getGlobalWindow_1.getWindow)();
    wd.__sgm__ = sgmFunc;
};
exports.setSgmReport = setSgmReport;
